module.exports = __webpack_public_path__ + "img/t2-6.cd68b1b1.png";